import React from "react";
import { Container, LoadingSpin } from "./style";

export default function Loading() {
  return (
    <Container>
      <LoadingSpin />
    </Container>
  );
}
